// extracted by mini-css-extract-plugin
export default {"debounceInput":"DebounceSearchInput_debounceInput__v5lYu"};